import React, { Component } from 'react'
import { Card, CardText } from 'material-ui/Card'
import { Table, TableBody, TableRow, TableRowColumn, TableHeaderColumn } from 'material-ui/Table'
import RaisedButton from 'material-ui/RaisedButton'

import { browserHistory } from 'react-router'
import api from '../../api'
import Spacer from '../spacer'

const buttonStyle = {
  downloadButton: {
    float: 'right'
  }
}

const styles = {
  root: {
    paddingLeft: '0'
  },
  table: {
    maxWidth: '800px'
  },
  tableRowCol: {
    textTransform: 'capitalize'
  }
}
class LogDetail extends Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      url: null,
      log: {
        csv_file_name: '',
        status: '',
        updated_at: '',
        user_name: '',
        created_at: '',
        log_items: []
      }
    }
  }

  componentWillMount () {
    api.get(`admin/member_import_logs/${this.props.params.logId}`)
      .then(res => res.json())
      .then(json => {
        this.setState({ log: json })
      })
  }

  downloadFile = () => {
    api.get(`admin/member_import_logs/download/${this.props.params.logId}`)
      .then(res => res.json())
      .then(json => {
        window.open(json.url, '_blank')
      })
  }

  render () {
    return (
      <div>
        <Spacer />
        <RaisedButton
          label='Back'
          onClick={this.handleBack.bind(this)}
        />
        <RaisedButton
          label='Download File'
          target='_blank'
          onClick={this.downloadFile}
          style={buttonStyle.downloadButton}
          disabled={this.state.log.status === 'failed'}
        />
        <Card style={{ boxShadow: 'none' }}>
          <CardText style={{ paddingLeft: '0' }}>
            <Table style={styles.table}>
              <TableBody selectable={false} displayRowCheckbox={false}>
                <TableRow style={{ borderBottom: 'none' }}>
                  <TableRowColumn style={{ fontSize: '15px', whiteSpace: 'none', width: '500px', paddingLeft: '0' }}>{this.state.log.csv_file_name}</TableRowColumn>
                  <TableRowColumn style={styles.tableRowCol}>{this.state.log.status}</TableRowColumn>
                </TableRow>
                <Spacer />
                <TableRow style={{ borderBottom: 'none', color: 'rgba(0, 0, 0, 0.54)', height: '15px' }}>
                  <TableHeaderColumn style={{ height: '15px', paddingLeft: '0' }}>Created</TableHeaderColumn>
                  <TableHeaderColumn style={{ height: '15px' }}>Uploaded by</TableHeaderColumn>
                </TableRow>
                <TableRow style={{ borderBottom: 'none', height: '15px' }}>
                  <TableRowColumn style={{ height: '15px', paddingLeft: '0' }}>{this.state.log.created_at}</TableRowColumn>
                  <TableRowColumn style={{ height: '15px' }}>{this.state.log.user_name}</TableRowColumn>
                </TableRow>
                <Spacer />
                {
                  this.state.log.log_items.length && // this line would show the below block when there is length
                  (
                    <div>
                      <TableRow style={{ borderBottom: 'none', color: 'rgba(0, 0, 0, 0.54)', height: '15px' }}>
                        <TableHeaderColumn style={{ height: '15px', paddingLeft: '0' }}>List of Error Occurs</TableHeaderColumn>
                      </TableRow>
                      {
                        this.state.log.log_items.map(item => (
                          <TableRow key={item.id} style={{ borderBottom: 'none', height: '15px' }}>
                            <TableRowColumn style={{ height: '15px', paddingLeft: '0' }}>Line: {item.line} - {item.message}</TableRowColumn>
                          </TableRow>
                        ))
                      }
                    </div>
                  )
                }

              </TableBody>
            </Table>
          </CardText>
        </Card>
      </div>
    )
  }

  handleBack (e) {
    e.preventDefault()
    browserHistory.goBack()
  }
}

export default LogDetail
